import React, { useState } from 'react';

import { inject, observer } from 'mobx-react'

import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect';
import pubsub from '@lib/scripts/pubsub'
import ListH5 from '@widget/market/TradeList/ListH5';
import { getListData } from '@widget/market/TradeList/utils';

function DefaultListItem (props) {
  const {
    tab,
    marketStore,
    loading,
    setDrawerVisible
  } = props;
  const [dataSource, setDataSource] = useState()
  useIsomorphicLayoutEffect(() => {
    setDataSource(getListData(
      tab?.currency,
      marketStore
    ))
  }, [marketStore.marketSymbols])
  console.log(setDrawerVisible, 'setDrawerVisible2222')
  return (
    <ListH5
      dataSource={dataSource}
      loading={loading}
      type='drawer'
      setDrawerVisible={setDrawerVisible}
      showFavorite={true}
      onItemClickCallBack={() => pubsub.publish('TRADE_DRAWER_CLOSE')}
    />
  )
}
export default inject(rootStore => ({
  marketStore: rootStore.store.marketStore
}))(observer(DefaultListItem))
